import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { ReactComponent as BackIcon } from '@pkg/assets/images/artifacts/back.svg';
import { CelestialRosesNavigation, CountHeading, EffectSlideIn } from '@pkg/components';

import './CelestialRosesSidebar.scss';

type CelestialRosesSidebarProps = {
    totalCount?: number;
    ownedCount?: number;
};

export function CelestialRosesSidebar({ totalCount = 0, ownedCount = 0 }: CelestialRosesSidebarProps) {
    const { t } = useTranslation(['artifacts']);

    return (
        <div className="yat-artifacts__celestial-roses-sidebar">
            <Link className="yat-artifacts__celestial-roses-sidebar__back" to="/artifacts/celestial-rose">
                <BackIcon /> {t('back_to_all_artifacts')}
            </Link>

            <h1 className="yat-artifacts__celestial-roses-sidebar__title">
                <EffectSlideIn>{t('celestial_rose')}</EffectSlideIn>
            </h1>

            <div className="yat-artifacts__celestial-roses-sidebar__counts">
                <CountHeading count={totalCount}>{t('total')}</CountHeading>
                <CountHeading count={ownedCount}>{t('owned')}</CountHeading>
            </div>
            <hr className="yat-artifacts__celestial-roses-sidebar__separator" />
            <CelestialRosesNavigation />
        </div>
    );
}
